import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Typography from '@mui/material/Typography';

const PageNotAccessible = () => {
  const isAuthenticated = Boolean(sessionStorage.getItem("isAuthenticated"));

  if (!isAuthenticated) {
    return (
      <Container maxWidth={false}>
        <Alert sx={{ border: 1, padding: 2, mx: 2, marginTop: 5 }}  severity="info">Please login clicking the LOGIN link in the upper right of this page.</Alert>
      </Container>
    )
  }
}

export default PageNotAccessible;